// extracted by mini-css-extract-plugin
module.exports = {"header":"ChangePasswordHeader_header__1FSr_","headerTitle":"ChangePasswordHeader_headerTitle__Sqmr1","headerIcon":"ChangePasswordHeader_headerIcon___YRvE"};